module.exports = __webpack_public_path__ + "static/media/Kohlrabi, purple.ba82e91c.png";